
  import * as netlifyRuntime$_6dlHKw2JTeBnpA_GlCZCFkUV6iREf6Sig_4523QqnDD8A from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_srvx@0.11.15/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 85
},
    providers: {
        ['netlify']: { provider: netlifyRuntime$_6dlHKw2JTeBnpA_GlCZCFkUV6iREf6Sig_4523QqnDD8A, defaults: {} }
    }
  }
